import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import firstAccessMessages from '../../../../messages/user-access/firstAccess.messages';
import { ErrorMessages } from '../../../../model/error';
import { isPasswordValid } from '../../../../utils/validators';
import { FirstAccessError, FirstAccessParams } from './first-access-types';

/**
 * Method that verifies first access page form values
 * @param formValues Values inserted by the user in the first access page
 * @returns undefined if everything is ok, or a FirstAccessError otherwise
 */
export const verifyFirstAccessCredentials = (
  formValues: FirstAccessParams
): FirstAccessError | undefined => {
  const { newPassword, newPasswordConfirm, oldPassword, username } = formValues;

  if (!newPassword || !newPasswordConfirm || !oldPassword || !username) {
    return 'FILL_ALL_FIELDS';
  }
  if (newPassword !== newPasswordConfirm) {
    return 'PASSWORDS_NOT_MATCHING';
  }
  if (newPassword === oldPassword) {
    return 'PASSWORD_ALREADY_USED';
  }
  if (!isPasswordValid(newPassword, username)) {
    return 'INVALID_PASSWORD_FORMAT';
  }
  return undefined;
};

export const messagesForFirstAccessError = (
  error: FirstAccessError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
    case 'PASSWORD_VECCHIA_NON_VALIDA':
      return {
        title: commonErrorMessages.errorDescriptionPasswordVecchia
      };
    case 'INVALID_CREDENTIALS':
      return { title: firstAccessMessages.errorTitleInvalidCredentials };
    case 'INVALID_PASSWORD_FORMAT':
      return {
        title: firstAccessMessages.errorTitleInvalidCriteria,
        description: firstAccessMessages.errorDescriptionInvalidCriteria,
      };
    case 'PASSWORDS_NOT_MATCHING':
      return { title: firstAccessMessages.errorTitlePasswordNotMatching };
    case 'PASSWORD_ALREADY_USED':
      return { title: firstAccessMessages.errorTitlePasswordAlreadyUsed };
    case 'FILL_ALL_FIELDS':
      return { title: firstAccessMessages.errorTitleFillInAllFields };
  }
};
